import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import MoveCardSection from "../Components/MoveCardSection";
import QuoteForm from "../Components/QuoteForm";
import { url, header } from "../Constent/Constant";
import TypeOfMoving from "../Components/TypeOfMoving";


function CommercialMoving() {
  const [CommercialMovingData, setCommercialMovingData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Commercial Moving"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setCommercialMovingData(data.doc)
      })
  }

  const OnFormFill = (ObjectData) => {
    if (ObjectData !== null) {
      fetch(`${url}/page/requestaquote`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            firstname: ObjectData.fName,
            lastname: ObjectData.lName,
            email: ObjectData.email,
            phone: ObjectData.phone
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            message.success('Thank You')
          }
        })
    } else {
      console.error('Not fill Correctly')
    }
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };

  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if(event.key === 'Enter'){
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    }else{
      console.log(event.key)
    }
  }

  return (
    <Layout>
      {CommercialMovingData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: CommercialMovingData.section1image1._id,
          headingId: CommercialMovingData.section1heading1._id
        }}
        Image={CommercialMovingData.section1image1.image} />}

      {CommercialMovingData && <MoveCardSection
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        CardData={CommercialMovingData} />}

      {CommercialMovingData && <div className='Commercial-Quote'>
        <h2> {CommercialMovingData.section4heading1.content}
          <i onClick={() => ShowTextModal(CommercialMovingData.section4heading1._id)} className="far fa-edit Edit-btn"></i>
        </h2>
        <div className='Commercial-Section'>
          <div className='Commercial-left-box'>
            <i onClick={() => showImageModal(CommercialMovingData.section5image1._id)} className="far fa-edit Edit-btn"></i>
            <img src={`${url}/api/getFile${CommercialMovingData.section5image1.image}`} alt="Img" />
          </div>
          <div className='Commercial-right-box'>
            <QuoteForm OnSubmit={OnFormFill} />
          </div>
        </div>
      </div>}


      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e)=> OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Text...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default CommercialMoving;
